import {
    Card, CardContent, Button, makeStyles, FormControl, Snackbar, RadioGroup, FormControlLabel, Radio, CircularProgress
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import axiosWithAuthInterceptor from '../util/axiosWithAuthInterceptor';
import { getRoles } from '../auth-provider/ra-auth-jwt';
import qs from 'qs'

interface authTokenGroupBy {
    [key: string]: Array<authToken>
}

interface authToken {
    createdAt: string,
    expirationDate: string,
    gateway: string,
    id: string,
    isEnabled: boolean,
    token: string,
    updatedAt: string
}

const LIMOOME_SHOP_SERVICE = 'LIMOOME_SHOP';
const SNAPP_GATEWAYS = ['SNAPP_PAY', 'ZEENAJI_SNAPP_PAY', 'LIMOSOFT_SNAPP_PAY'];
const DIGIPAY_GATEWAYS = ['LIMOOME_DIGIPAY', 'LIMOSOFT_DIGIPAY'];

const gateway: Record<string, string> = {
    PAYPING: "پی‌پینگ",
    VANDAR: "وندار",
    SNAPP_PAY: "اسنپ‌پی",
    ZEENAJI_SNAPP_PAY: "زیناجی اسنپ‌پی",
    LIMOSOFT_SNAPP_PAY: "لیموسافت اسنپ‌پی",
    LIMOOME_DIGIPAY: "لیمومی دیجی‌پی",
    LIMOSOFT_DIGIPAY: "لیموسافت دیجی‌پی",
    ZEENAJI_PAYPING: "زیناجی پی‌پینگ",
    LIMOOME_ZIFY: "زیفای",
    LIMOSOFT_PAYPING: "لیموسافت پی‌پینگ",
    SIBDIET_PAYPING: "سیب‌دایت پی‌پینگ"
}

const useStyles = makeStyles((theme) => ({
    cancelBtn: {
        backgroundColor: 'rgb(220, 0, 78)',
        width: '20%',
        '&:hover': {
            backgroundColor: 'rgb(220, 0, 78)'
        }
    }
}));

async function getTokens() {
    const filters = {
        where: {
            gateway: {
                in: ["PAYPING", "VANDAR", "LIMOOME_ZIFY", "LIMOSOFT_PAYPING", "SIBDIET_PAYPING"]
            }
        }
    }
    const strigifiedFilters = qs.stringify(filters)
    return await axiosWithAuthInterceptor({
        url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/authTokens?${strigifiedFilters}`,
        method: 'GET'
    })
}

async function getActiveSnappGateway() {
    return await axiosWithAuthInterceptor({
        url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/paymentGatewaySettings/active-snapp-gateway?service=${LIMOOME_SHOP_SERVICE}`,
        method: 'GET'
    })
}

async function getDigipayAccounts() {
    return await axiosWithAuthInterceptor({
        url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/digipayAccounts?service=${LIMOOME_SHOP_SERVICE}`,
        method: 'GET'
    })
}

export function UpdatePaymentGatewayManager() {
    const classes = useStyles();
    const [authTokensGroupBy, setAuthTokenGroupBy] = useState<authTokenGroupBy>({});
    const [sendDataToServer, setSendDataToServer] = useState<Array<any>>([])
    const [selectedSnappGateway, setSelectedSnappGateway] = useState('');
    const [originalSnappGateway, setOriginalSnappGateway] = useState('');
    const [digipayAccounts, setDigipayAccounts] = useState<any[]>([]);
    const [selectedDigipayAccountId, setSelectedDigipayAccountId] = useState('');
    const [originalDigipayAccountId, setOriginalDigipayAccountId] = useState('');
    const [serverState, setServerState] = useState({
        status: 'NONE',
        message: '',
    })
    const [submitState, setSubmitState] = useState({
        status: 'NONE',
        message: '',
    })

    const getValue = (getway: string) => {
        let selectedAuthToken = authTokensGroupBy[getway].find((authToken: any) => authToken.isEnabled === true)
        return selectedAuthToken?.token ? selectedAuthToken.token : '';
    }

    const changeSelectedValue = (getway: string, authTokenId: string, e: any) => {
        let newAuthTokenGroupBy = authTokensGroupBy[getway].map((authToken: any) => {
            if (authToken.id === authTokenId) {
                let isExist = sendDataToServer.some((t: any) => t.gateway === getway)
                if (!isExist) {
                    let data = { gateway: getway, id: authToken.id }
                    setSendDataToServer([...sendDataToServer, { ...data }])
                }
                else {
                    let data = sendDataToServer.map((d) => {
                        if (d.gateway === getway)
                            return { ...d, id: authToken.id }
                        else
                            return d
                    })
                    setSendDataToServer(data)
                }
                return { ...authToken, isEnabled: true }
            }
            return { ...authToken, isEnabled: false }
        })
        setAuthTokenGroupBy({ ...authTokensGroupBy, [getway]: newAuthTokenGroupBy })
    }

    const submit = async () => {
        setSubmitState({ status: "NONE", message: "" })

        let promises: Array<any> = []

        sendDataToServer.forEach((sendData: any) => {
            promises.push(prepareUpdateRequest(sendData))
        });

        if (selectedSnappGateway && selectedSnappGateway !== originalSnappGateway) {
            promises.push(updateActiveSnappGateway(selectedSnappGateway))
        }

        if (selectedDigipayAccountId && selectedDigipayAccountId !== originalDigipayAccountId) {
            promises.push(enableDigipayAccount(selectedDigipayAccountId))
        }

        if (promises.length === 0) {
            return
        }

        Promise.all(promises)
            .then(res => {
                setSubmitState({ status: "SUCCESSFUL", message: "تغییرات با موفقیت انجام شد." })
                document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-successful')
                if (selectedSnappGateway !== originalSnappGateway) {
                    setOriginalSnappGateway(selectedSnappGateway)
                }
                if (selectedDigipayAccountId !== originalDigipayAccountId) {
                    setOriginalDigipayAccountId(selectedDigipayAccountId)
                }
            })
            .catch(e => {
                setSubmitState({ status: "ERROR", message: "خطا در ثبت" })
                document.querySelector('.MuiSnackbarContent-root')?.classList.add('snack-error')
            })
            .finally(() => {
                setSendDataToServer([])
            })
    }

    const prepareUpdateRequest = async (request: any) => {
        await axiosWithAuthInterceptor({
            url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/authTokens/active-token`,
            data: { activeTokenId: request.id },
            method: 'PATCH'
        })
    }

    const updateActiveSnappGateway = async (gate: string) => {
        await axiosWithAuthInterceptor({
            url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/paymentGatewaySettings/active-snapp-gateway`,
            data: { service: LIMOOME_SHOP_SERVICE, gateway: gate },
            method: 'PATCH'
        })
    }

    const enableDigipayAccount = async (accountId: string) => {
        await axiosWithAuthInterceptor({
            url: `${process.env.REACT_APP_LEMONADE_SERVER}/api/digipayAccounts/${accountId}/enable`,
            method: 'PATCH'
        })
    }

    const convertOriginalToGroupBy = (tokens: Array<any>) => {
        let tokensGroupBy = tokens.reduce((group, cp) => {
            const { gateway } = cp;
            group[gateway] = group[gateway] ?? [];
            group[gateway].push(cp);
            return group;
        }, {});
        return tokensGroupBy;
    }

    const getGatewayNameFa = (gatewayName: string) => {
        return gateway[gatewayName]
    }

    const showSnappGatewaySection = () => {
        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <p style={{ marginTop: '2rem', marginBottom: '0px', fontFamily: 'IranSans-Bold' }}>اسنپ‌پی</p>
                <hr style={{ height: '1px', border: '0', borderTop: '1px solid #ccc' }}></hr>
                <FormControl component="fieldset">
                    <RadioGroup
                        style={{ gap: '0.25rem' }}
                        value={selectedSnappGateway}
                        onChange={(e: any) => setSelectedSnappGateway(e.target.value)}
                    >
                        {SNAPP_GATEWAYS.map((snappGateway) => (
                            <FormControlLabel
                                key={snappGateway}
                                style={{ flexDirection: 'row', fontFamily: 'IranSans-Thin' }}
                                value={snappGateway}
                                control={<Radio />}
                                label={getGatewayNameFa(snappGateway)}
                            />
                        ))}
                    </RadioGroup>
                </FormControl>
            </div>
        )
    }

    const showDigipayGatewaySection = () => {
        if (digipayAccounts.length === 0) return null

        const enabledAccount = digipayAccounts.find((account) => account.isEnabled)
        const activeAccountId = selectedDigipayAccountId || enabledAccount?.id || ''

        return (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
                <p style={{ marginTop: '2rem', marginBottom: '0px', fontFamily: 'IranSans-Bold' }}>دیجی‌پی</p>
                <hr style={{ height: '1px', border: '0', borderTop: '1px solid #ccc' }}></hr>
                <FormControl component="fieldset">
                    <RadioGroup
                        style={{ gap: '0.25rem' }}
                        value={activeAccountId}
                        onChange={(e: any) => setSelectedDigipayAccountId(e.target.value)}
                    >
                        {digipayAccounts
                            .filter((account) => DIGIPAY_GATEWAYS.includes(account.gateway))
                            .map((account) => (
                                <FormControlLabel
                                    key={account.id}
                                    style={{ flexDirection: 'row', fontFamily: 'IranSans-Thin' }}
                                    value={account.id}
                                    control={<Radio />}
                                    label={getGatewayNameFa(account.gateway)}
                                />
                            ))}
                    </RadioGroup>
                </FormControl>
            </div>
        )
    }

    const showContent = () => {
        switch (serverState.status) {
            case "SUCCESSFULL":
                return (
                    <>
                        {Object.keys(authTokensGroupBy).map((getwayName: string) => {
                            return (
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }} key={getwayName}>
                                    <p style={{ marginTop: '2rem', marginBottom: '0px', fontFamily: 'IranSans-Bold' }} key={getwayName}>{getGatewayNameFa(getwayName)}</p>
                                    <hr style={{ height: '1px', border: '0', borderTop: '1px solid #ccc' }}></hr>
                                    {
                                        authTokensGroupBy[getwayName].sort(sortAuthToken).map((authToken: any) => {
                                            return (
                                                <FormControl key={authToken.id} component="fieldset">
                                                    <RadioGroup style={{ gap: '0.25rem' }} value={getValue(getwayName)} onChange={(e: any) => changeSelectedValue(getwayName, authToken.id, e)}>
                                                        <FormControlLabel style={{ flexDirection: 'row', fontFamily: 'IranSans-Thin' }} value={authToken.token} control={<Radio />} label={authToken.token.substring(authToken.token.length - 20, authToken.token.length)} />
                                                    </RadioGroup>
                                                </FormControl>
                                            )
                                        })
                                    }
                                </div>
                            )
                        })}
                        {showSnappGatewaySection()}
                        {showDigipayGatewaySection()}
                    </>
                )
            case "PENDING":
                return (
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem' }}>
                        <CircularProgress />
                    </div>
                )
            case "ERROR":
                return (
                    <p style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '5rem', color: 'red' }}>خطا در دریافت لیست توکن‌ها</p>
                )
            default:
                break;
        }
    }

    const sortAuthToken = (a: any, b: any) => {
        if (a.createdAt < b.createdAt) {
            return 1;
        }
        if (a.createdAt > b.createdAt) {
            return -1;
        }
        return 0;
    }

    useEffect(() => {
        setServerState({ status: "PENDING", message: "" })
        Promise.all([getTokens(), getActiveSnappGateway(), getDigipayAccounts()])
            .then(([tokensRes, activeSnappRes, digipayAccountsRes]: any[]) => {
                let result = convertOriginalToGroupBy(tokensRes.data);
                setAuthTokenGroupBy(result);

                const activeSnappGateway = activeSnappRes.data
                if (activeSnappGateway && SNAPP_GATEWAYS.includes(activeSnappGateway)) {
                    setSelectedSnappGateway(activeSnappGateway)
                    setOriginalSnappGateway(activeSnappGateway)
                }

                const accounts = digipayAccountsRes.data || []
                setDigipayAccounts(accounts)
                const enabledAccount = accounts.find((account: any) => account.isEnabled)
                if (enabledAccount) {
                    setSelectedDigipayAccountId(enabledAccount.id)
                    setOriginalDigipayAccountId(enabledAccount.id)
                }

                setServerState({ status: "SUCCESSFULL", message: "" })
            }).catch((e: any) => {
                setServerState({ status: "ERROR", message: "" })
            })
        let roles = getRoles();
        let isPaymentManager = roles.some((r: any) => r === `${process.env.REACT_APP_AUTH_SERVICE}.payment_manager`)
        if (!isPaymentManager)
            window.location.href = '/'
    }, [])

    return (
        <Card>
            <CardContent>
                <div className="dashboard-card" onClick={() => window.location.href = `${process.env.REACT_APP_AUTH_PUBLIC_PATH}/#/payment-gateway-manager/create`}>
                    <p style={{ fontFamily: 'IranSans-Bold' }}>ایجاد توکن</p>
                </div>
                {showContent()}
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '2rem', justifyContent: 'space-between' }}>
                    <Button onClick={() => submit()} style={{ color: '#fff' }} variant="contained" color="primary">ثبت</Button>
                </div>
                <Snackbar
                    open={submitState.status === 'ERROR' || submitState.status === 'SUCCESSFUL' ? true : false}
                    onClose={() => {
                        setSubmitState({ ...submitState, status: 'NONE' })
                    }}
                    autoHideDuration={3000}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    message={submitState.message}
                    style={{ backgroundColor: 'transparent', borderRadius: '12px' }}
                />
            </CardContent>
        </Card >
    )
}
